






































import { Component, Mixins, Prop, Vue } from 'vue-property-decorator'
import { map } from 'lodash'
import { Circuit, Exercise } from '@/interfaces'
import { decimalToPercent } from '@/utils'
import CountdownTimer from '@/components/CountdownTimer.vue'
import ExerciseList from '@/components/ExerciseList.vue'
import CircuitMixin from '@/mixins/CircuitMixin'

@Component({
  components: { CountdownTimer, ExerciseList }
})
export default class CircuitPlayer extends Mixins(CircuitMixin) {
  @Prop({ default: '' }) circuitId!: string

  $refs: any = {
    timer: CountdownTimer
  }

  exerciseIndex: number = 0
  setIndex: number = 0

  get circuitProgress () {
    const totalExercises = this.circuitExercises.length
    const totalProgress = totalExercises // * this.circuit.numberOfSets
    const acutalProgress = (totalExercises * this.setIndex) + this.exerciseIndex

    return decimalToPercent(acutalProgress / totalProgress)
  }

  get exercise (): Exercise {
    return this.circuitExercises[this.exerciseIndex]
  }

  navigateBack () {
    this.$router.push({ name: 'circuit-info', params: { circuitId: this.circuitId } })
  }

  nextExercise () {
    if (this.exerciseIndex < this.circuitExercises.length - 1) {
      this.setPosition(this.setIndex, this.exerciseIndex + 1)

      return
    }

    // if (this.setIndex < this.circuit.numberOfSets - 1) {
    //   this.setPosition(this.setIndex + 1, 0)

    //   return
    // }

    this.navigateBack()
  }

  onCountdownTimerFinished () {
    this.nextExercise()
  }

  setPosition (setIndex: number, exerciseIndex: number) {
    this.exerciseIndex = exerciseIndex
    this.setIndex = setIndex

    this.$nextTick(() => {
      // if (this.exercise.duration) {
      //   this.$refs.timer.start(this.exercise.duration)
      // }
    })
  }
}
